// prettier really wants the semicolon to be there...
// eslint-disable-next-line no-extra-semi
;(() => {
  const mobileHeader = document.querySelector('header.-mobile')
  const profileMenu = document.getElementById('mobile-user-menu')
  const profileToggle = document.querySelector(
    'header.-mobile .menu-item--profile-toggle'
  )

  const burgerMenu = document.getElementById('dhsv-mobile-menu-panel')
  const burgerMenuItems = document.querySelectorAll(
    '.dhsv-mobile-menu .menu>li'
  )
  const burgerMenuBack = document.querySelector(
    '.dhsv-mobile-menu button.title'
  )
  const burgerToggle = document.querySelector(
    'header.-mobile .menu-item--burger-toggle'
  )
  const mobileMedia = window.matchMedia('(max-width: 1023.98px)')
  const focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]',
  ].join(',')

  function setFocusDisabled(root, disabled) {
    if (!root) return

    root.toggleAttribute('inert', disabled)
    if (disabled) {
      root.setAttribute('aria-hidden', 'true')
    } else if (root !== profileMenu && root !== burgerMenu) {
      root.removeAttribute('aria-hidden')
    }

    root.querySelectorAll(focusableSelector).forEach(element => {
      if (disabled) {
        if (!element.hasAttribute('data-original-tabindex')) {
          element.setAttribute(
            'data-original-tabindex',
            element.getAttribute('tabindex') || ''
          )
        }
        element.setAttribute('tabindex', '-1')
        return
      }

      if (!element.hasAttribute('data-original-tabindex')) return
      const originalTabindex = element.getAttribute('data-original-tabindex')
      if (originalTabindex === '') {
        element.removeAttribute('tabindex')
      } else {
        element.setAttribute('tabindex', originalTabindex)
      }
      element.removeAttribute('data-original-tabindex')
    })
  }

  function syncMobileFocusState() {
    const isMobile = mobileMedia.matches

    setFocusDisabled(mobileHeader, !isMobile)
    setFocusDisabled(
      profileMenu,
      !isMobile || !profileMenu || !profileMenu.classList.contains('open')
    )
    setFocusDisabled(
      burgerMenu,
      !isMobile || !burgerMenu || !burgerMenu.classList.contains('open-menu')
    )
  }

  function setProfileOpen(open) {
    if (!profileMenu || !profileToggle) return
    profileMenu.classList.toggle('open', open)
    profileToggle.closest('.menu-item').classList.toggle('active', open)
    profileToggle.setAttribute('aria-expanded', String(open))
    profileMenu.setAttribute('aria-hidden', String(!open))
    setFocusDisabled(profileMenu, !open || !mobileMedia.matches)
  }

  function setBurgerOpen(open) {
    if (!burgerMenu || !burgerToggle) return
    burgerMenu.classList.toggle('open-menu', open)
    burgerToggle.closest('.menu-item').classList.toggle('active', open)
    burgerToggle.setAttribute('aria-expanded', String(open))
    burgerMenu.setAttribute('aria-hidden', String(!open))
    setFocusDisabled(burgerMenu, !open || !mobileMedia.matches)
  }

  function openSubmenuForItem(item) {
    if (!burgerMenu || !item.classList.contains('has-children')) return
    if (item.classList.contains('active')) return
    burgerMenu.classList.add('changed')
    setTimeout(() => {
      burgerMenu.classList.remove('changed')
      burgerMenu.classList.add('open-sub')
      item.classList.add('active')
    }, 500)
  }

  document.addEventListener('click', e => {
    if (profileToggle && profileMenu && profileToggle.contains(e.target)) {
      setProfileOpen(!profileMenu.classList.contains('open'))
    }

    if (
      profileToggle &&
      profileMenu &&
      !profileToggle.contains(e.target) &&
      !profileMenu.contains(e.target) &&
      profileMenu.classList.contains('open')
    ) {
      setProfileOpen(false)
    }

    if (burgerToggle && burgerMenu && burgerToggle.contains(e.target)) {
      setBurgerOpen(!burgerMenu.classList.contains('open-menu'))
    }

    if (burgerMenu && burgerMenuBack && burgerMenuBack.contains(e.target)) {
      burgerMenu.classList.add('changed')
      setTimeout(() => {
        burgerMenu.classList.remove('changed')

        burgerMenu.classList.remove('open-sub')
        burgerMenuItems.forEach(item => {
          item.classList.remove('active')
        })
      }, 500)
    }
  })

  burgerMenuItems.forEach(item => {
    item.addEventListener('click', e => {
      if (
        e.target.parentNode === item &&
        !item.classList.contains('active') &&
        item.classList.contains('has-children')
      ) {
        e.preventDefault()
        openSubmenuForItem(item)
      }
    })
    const directLink = item.querySelector(':scope > a')
    if (directLink) {
      directLink.addEventListener('keydown', e => {
        if (e.key !== 'Enter' && e.key !== ' ') return
        if (!item.classList.contains('has-children')) return
        if (item.classList.contains('active')) return
        e.preventDefault()
        openSubmenuForItem(item)
      })
    }
  })

  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return
    if (
      profileMenu &&
      profileToggle &&
      profileMenu.classList.contains('open')
    ) {
      setProfileOpen(false)
      profileToggle.focus()
    }
    if (
      burgerMenu &&
      burgerToggle &&
      burgerMenu.classList.contains('open-menu')
    ) {
      if (burgerMenu.classList.contains('open-sub')) {
        burgerMenu.classList.add('changed')
        setTimeout(() => {
          burgerMenu.classList.remove('changed')
          burgerMenu.classList.remove('open-sub')
          burgerMenuItems.forEach(item => item.classList.remove('active'))
        }, 500)
      } else {
        setBurgerOpen(false)
        if (burgerToggle) burgerToggle.focus()
      }
    }
  })

  syncMobileFocusState()
  if (mobileMedia.addEventListener) {
    mobileMedia.addEventListener('change', syncMobileFocusState)
  } else {
    mobileMedia.addListener(syncMobileFocusState)
  }
})()
